// MediaPlugin for MarkdownIt to handle audio and video tags
const AUDIO_REGEX =
  /<audio\s+[^>]*?src\s*=\s*["']([^"']*?)["'][^>]*?(?:\s*\/)?>/gi;
const VIDEO_REGEX =
  /<video\s+[^>]*?src\s*=\s*["']([^"']*?)["'][^>]*?(?:\s*\/)?>/gi;

const processMediaTags = text => {
  // 首先将中文双引号替换为英文双引号
  const normalizeQuotes = str => {
    // 使用字符类匹配所有类型的中文引号，一次性处理
    return str.replace(/src\s*=\s*[“]([^"""]*?)[”]/g, 'src="$1"');
  };

  text = normalizeQuotes(text);

  // 处理 audio 标签
  text = text.replace(AUDIO_REGEX, (match, src) => {
    // 处理 URL 中的空格和编码
    const cleanSrc = encodeURI(src.trim());
    const hasControls = match.includes('controls');
    const controlsAttr = hasControls ? ' controls' : '';

    return `<audio${controlsAttr} class="skip-context-menu" style="width: 100%; max-width: 400px;">
      <source src="${cleanSrc}" type="audio/mpeg" />
    </audio>`;
  });

  // 处理 video 标签
  text = text.replace(VIDEO_REGEX, (match, src) => {
    // 处理 URL 中的空格和编码
    const cleanSrc = encodeURI(src.trim());
    const hasControls = match.includes('controls');
    const controlsAttr = hasControls ? ' controls' : '';

    return `<video${controlsAttr} class="skip-context-menu" style="width: 100%; max-width: 500px; height: auto;">
      <source src="${cleanSrc}" type="video/mp4" />
    </video>`;
  });

  return text;
};

const mediaPlugin = md => {
  // 在 markdown 渲染之前预处理文本
  md.core.ruler.before('normalize', 'media_tags', state => {
    state.src = processMediaTags(state.src);
  });
};

export default mediaPlugin;
